module.exports = __webpack_public_path__ + "img/more-info.b965f968.svg";